jQuery(document).ready(function ($) {
  if (typeof Swiper === 'undefined') return;

  $('.rv-reviews-section').each(function () {
    var section   = $(this);
    var sectionId = section.attr('data-section-id');
    var autoOn    = section.attr('data-autoplay') === 'true';
    var autoSpeed = parseInt(section.attr('data-speed'), 10) || 3000;

    var swiper = new Swiper('#rv-slider-' + sectionId, {
      loop:       true,
      speed:      400,
      nextButton: '#rv-next-' + sectionId,
      prevButton: '#rv-prev-' + sectionId,
      slidesPerView: 4,
      spaceBetween: 0,
      breakpoints: {
        1279: { slidesPerView: 3 },
        899:  { slidesPerView: 2 },
        599:  { slidesPerView: 1 }
      }
    });

    if (autoOn) {
      var autoInterval = setInterval(function () { swiper.slideNext(); }, autoSpeed);
      section
        .on('mouseenter', function () { clearInterval(autoInterval); })
        .on('mouseleave', function () {
          autoInterval = setInterval(function () { swiper.slideNext(); }, autoSpeed);
        });
    }
  });
});
    